import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone, User } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contacts() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/contacts").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14" data-testid="contacts-page">
      <div className="mb-10">
        <span className="text-xs tracking-[0.3em] uppercase text-[#1E3A8A] font-bold">L'équipe du club</span>
        <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold text-[#0F172A] tracking-tighter" style={{ fontFamily: "Outfit" }}>
          Contacts<span className="text-[#DC2626]">.</span>
        </h1>
        <p className="mt-3 text-[#475569] max-w-2xl">
          Dirigeants, éducateurs et secrétariat : à chaque question son interlocuteur. Avant d'appeler, pensez à consulter la{" "}
          <Link to="/faq" className="text-[#1E3A8A] font-semibold hover:text-[#D97706]">FAQ</Link>.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((c) => (
          <div key={c.id} className="border border-[#E2E8F0] rounded-lg p-6 bg-white hover:border-[#1E3A8A] transition-colors" data-testid={`contact-${c.id}`}>
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#1E3A8A] to-[#1E40AF] text-white font-bold text-xl flex items-center justify-center shrink-0" style={{ fontFamily: "Outfit" }}>
                {c.photo_url ? <img src={c.photo_url} alt={c.name} className="w-full h-full object-cover rounded-full" /> : c.name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase()}
              </div>
              <div className="min-w-0">
                <div className="font-bold text-[#0F172A]" style={{ fontFamily: "Outfit" }}>{c.name}</div>
                <div className="text-xs tracking-[0.15em] uppercase text-[#D97706] font-semibold">{c.role}</div>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-[#E2E8F0] space-y-2 text-sm">
              {c.phone && (
                <a href={`tel:${c.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-[#475569] hover:text-[#1E3A8A] transition-colors">
                  <Phone size={14} /> {c.phone}
                </a>
              )}
              {c.email && (
                <a href={`mailto:${c.email}`} className="flex items-center gap-2 text-[#475569] hover:text-[#1E3A8A] transition-colors break-all">
                  <Mail size={14} /> {c.email}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 p-6 bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <div className="font-bold text-[#0F172A]" style={{ fontFamily: "Outfit" }}>Une question générale ?</div>
          <p className="text-sm text-[#475569]">Préférez le formulaire pour un suivi écrit — réponse sous 48h.</p>
        </div>
        <Link to="/contact" data-testid="contacts-cta-form" className="px-5 py-2.5 rounded-md bg-[#1E3A8A] text-white font-semibold hover:bg-[#1E40AF] transition-colors">
          Ouvrir le formulaire
        </Link>
      </div>
    </div>
  );
}
